'use strict'

import * as React from 'react'
import { Bottleneck } from '../domain/Bottleneck'
import { connect } from 'react-redux'
import { ApplicationState } from '../redux/ApplicationState'
import Shorten from './shorten'

interface Props {
    bottlenecks: Bottleneck
    bottleneckTypes: string[]
    bottleneckMetadata: {
        [type: string]: {
            label: string
            hidden: boolean
        }
    }
}

export class Bottlenecks extends React.Component<Props> {
    public render() {
        const { bottlenecks, bottleneckMetadata } = this.props
        let { bottleneckTypes } = this.props

        if (bottleneckTypes.length > 0) {
            // filter bottlenecks which are detected but not shown due to missing feature flag
            bottleneckTypes = bottleneckTypes.filter(type => bottleneckMetadata[type]?.hidden !== true)

            if (bottleneckTypes.length === 0) {
                return
            }

            const renderItem = (type: string) => (
                <span key={type} className="label label-bottleneck label-danger" title={bottleneckMetadata[type]?.label || type}>
                    <Shorten length={12} string={bottleneckMetadata[type]?.label || type} />
                </span>
            )

            if (bottleneckTypes.length < 3) {
                return <span>{bottleneckTypes.map(renderItem)}</span>
            }

            return (
                <span>
                    {renderItem(bottleneckTypes[0])}
                    <span className="label label-bottleneck label-danger">and {bottleneckTypes.length - 1} more ...</span>
                </span>
            )
        }

        return (
            <span>
                {bottlenecks.nplus1 ? (
                    <span
                        className="label label-bottleneck label-danger"
                        title="Performs time consuming SQL Queries or HTTP calls repeatedly even though they are very similar."
                    >
                        N+1
                    </span>
                ) : null}
                {bottlenecks.sql ? (
                    <span
                        className="label label-bottleneck label-danger"
                        title="Performs SQL queries that take longer than 250ms in total."
                    >
                        SQL
                    </span>
                ) : null}
                {bottlenecks.http ? (
                    <span className="label label-bottleneck label-danger" title="Peforms HTTP calls that take longer than 250ms in total.">
                        HTTP
                    </span>
                ) : null}
                {bottlenecks.gc ? (
                    <span className="label label-bottleneck label-danger" title="Excessively triggers Garbage Collection">
                        GC
                    </span>
                ) : null}
                {bottlenecks.session ? (
                    <span className="label label-bottleneck label-danger" title="Blocking Session">
                        SESSION
                    </span>
                ) : null}
                {bottlenecks.xdebug ? (
                    <span
                        className="label label-bottleneck label-danger"
                        title="Xdebug is installed on the server and affects performance of this request."
                    >
                        XDEBUG
                    </span>
                ) : null}
                {bottlenecks.compile ? (
                    <span className="label label-bottleneck label-danger" title="Significant time was spent compiling the PHP files.">
                        COMPILE
                    </span>
                ) : null}
                {bottlenecks.wait ? (
                    <span className="label label-bottleneck label-danger" title="This trace has significant unaccounted CPU wait time">
                        WAIT
                    </span>
                ) : null}
            </span>
        )
    }
}

export default connect((globalState: ApplicationState) => ({
    bottleneckMetadata: globalState.tidewaysContext.bottlenecks,
}))(Bottlenecks)
